export const FEATURE_FLAG_SUBCATEGORIES = 'ftr-kb-subcategories'
export const RLS_KB_NEW_UI = 'rls-kb-new-ui'
/** Zendesk KB import flow (same key as web repo) */
export const KB_IMPORT_FEATURE_FLAG = 'ftr-kb-import'
export const KB_MULTI_KB_FEATURE_FLAG = 'ftr-kb-multi-kb'
export const KB_NEW_LOGIN_FEATURE_FLAG = 'ftr-kb-new-login'
export const AMPLITUDE_FEATURE_FLAG = 'rls-kb-amplitude'
export const KB_EXTERNAL_ACCESS_FEATURE_FLAG = 'ftr-kb-external-access'
export const KB_EDITOR_URL_LOAD_FEATURE_FLAG = 'ftr-kb-editor-url-load'
